import { render, staticRenderFns } from "./selectRoleType.vue?vue&type=template&id=15b5bcc2&scoped=true"
import script from "./selectRoleType.vue?vue&type=script&lang=js"
export * from "./selectRoleType.vue?vue&type=script&lang=js"
import style0 from "./selectRoleType.vue?vue&type=style&index=0&id=15b5bcc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b5bcc2",
  null
  
)

export default component.exports